export default function auth({ next, router }) {
  if (!localStorage.getItem('session') && !sessionStorage.getItem('session')) {
    return router.push({ name: 'auth-login' });
  }
  return next();
}